import ReportDownloadIcon from "@mui/icons-material/Download";
import ReportDownloadDoneIcon from "@mui/icons-material/DownloadDone";
import ReportDownloadingIcon from "@mui/icons-material/Downloading";
import CircularProgress from "@mui/material/CircularProgress";
import Divider from "@mui/material/Divider";
import ListItemIcon from "@mui/material/ListItemIcon";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import Typography from "@mui/material/Typography";
import { useDispatch, useSelector } from "react-redux";
import {
  downloadReport,
  selectIsReportCached,
  selectIsReportDownloading,
} from "../../redux/sales";

const SalesContextMenu = (props) => {
  const dispatch = useDispatch();

  const isReportCached = useSelector(selectIsReportCached);
  const isReportDownloading = useSelector(selectIsReportDownloading);

  const onDownloadReportClick = () => {
    dispatch(downloadReport());
    props.onClose();
  };

  return (
    <Menu
      anchorEl={props.menuRef.current}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      onClose={props.onClose}
      open={props.open}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      sx={{ "& .MuiPaper-root": { marginTop: "8px" } }}
    >
      <Divider>Sales Report</Divider>
      <MenuItem disabled={isReportDownloading} onClick={onDownloadReportClick}>
        <ListItemIcon>
          {isReportDownloading ? (
            <>
              <ReportDownloadingIcon sx={{ zIndex: 1 }} />
              <CircularProgress
                size={24}
                sx={{ position: "absolute" }}
                thickness={6}
              />
            </>
          ) : isReportCached ? (
            <ReportDownloadDoneIcon />
          ) : (
            <ReportDownloadIcon />
          )}
        </ListItemIcon>
        <Typography>Download Report</Typography>
      </MenuItem>
    </Menu>
  );
};

export default SalesContextMenu;
